import { createSlice } from "@reduxjs/toolkit";
import { deleteProfilePic } from "./Thunk";

const PAGESarray = [
  {
    pageName: "Dashboard",
    userRole: "Admin",
    url: "/dash",
  },
  { pageName: "Uygulamalar", userRole: "User", url: "/userdash" },
  {
    pageName: "Results",
    userRole: "User",
    url: "/myresults",
  },
  { pageName: "Profile", userRole: "User", url: "/myProfile" },
  {
    pageName: "Dashboard",
    userRole: "SuperAdmin",
    url: "/sdash",
  },
  { pageName: "Assessment", userRole: "SuperAdmin", url: "/assessment/" },
  {
    pageName: "Inventory",
    userRole: "SuperAdmin",
    url: "/inventory",
  },
  { pageName: "Test", userRole: "SuperAdmin", url: "/test" },
  {
    pageName: "Survey",
    userRole: "SuperAdmin",
    url: "/Survey/",
  },
  { pageName: "Results", userRole: "SuperAdmin", url: "/ApplicationResults/" },
  {
    pageName: "Company",
    userRole: "SuperAdmin",
    url: "/Company/",
  },
  { pageName: "TicketRefresh", userRole: "SuperAdmin", url: "/TicketEditor/" },
  {
    pageName: "Position",
    userRole: "Admin",
    url: "/createPosition/",
  },
  { pageName: "Candidate", userRole: "Admin", url: "/createCandidate/" },
  {
    pageName: "Project",
    userRole: "Admin",
    url: "/project/",
  },
  { pageName: "Company", userRole: "Admin", url: "/adminCompanyInfo/" },
  {
    pageName: "Squads",
    userRole: "Admin",
    url: "/squads/",
  },
  { pageName: "HelpDesk", userRole: "SuperAdmin", url: "/superAdminHelpDesk/" },
  { pageName: "Organization", userRole: "SuperAdmin", url: "/organization/" },
];

export const appMenu = createSlice({
  name: "appMenu",
  initialState: {
    id: "",
    pages: PAGESarray,
    selectedPage: {},
    screenSize:
      window.innerWidth < 500 ? "mobile-screen collapsed" : window.innerWidth > 1200 ? "large-screen" : "small-screen",
    profilePictureModalIsShown: false,
    reduxProfilePicture: null,
    isLoading: false,
  },
  reducers: {
    SetSelectedPage(state, action) {
      const selectedPage = PAGESarray.find((page) => page.url === action.payload.url) || null;
      state.selectedPage = selectedPage;
      window.location.href = window.location.origin + "/#" + selectedPage.url;
    },
    SetSelectedPageWithoutUrl(state, action) {
      const selectedPage = PAGESarray.find((page) => page.url === action.payload.url) || null;
      state.selectedPage = selectedPage;
    },
    SetScreenSizeCssClass(state, action) {
      state.screenSize = action.payload;
    },
    SetProfilePictureModalIsShown(state, action) {
      state.profilePictureModalIsShown = action.payload;
    },
    SetReduxProfilePicture(state, action) {
      state.reduxProfilePicture = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(deleteProfilePic.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteProfilePic.fulfilled, (state, action) => {
      state.isLoading = false;
      state.reduxProfilePicture = null;
    });
  },
});

export const {
  SetSelectedPage,
  SetSelectedPageWithoutUrl,
  SetScreenSizeCssClass,
  SetReduxProfilePicture,
  SetProfilePictureModalIsShown,
} = appMenu.actions;

export default appMenu.reducer;
